import { USER_DATA, USER_MENUS, USER_INFO, APPLICATION_CODES, TASK_ITEM, } from './types';
// System User Info
export var setUserDataRedux = function (payload) { return ({
    type: USER_DATA,
    payload: payload,
}); };
export var setUserMenusRedux = function (payload) { return ({
    type: USER_MENUS,
    payload: payload,
}); };
export var setApplicationCodesRedux = function (payload) { return ({
    type: APPLICATION_CODES,
    payload: payload,
}); };
export var setUserInfoRedux = function (payload) { return ({
    type: USER_INFO,
    payload: payload,
}); };
export var setTaskItemRedux = function (payload) { return ({
    type: TASK_ITEM,
    payload: payload,
}); };
